<template>
  <div>
    <el-drawer :modal="false"  title="Buy FintScore" :visible.sync="drawerBuyFintscoreReport" class="drawer-buy-fintscore" size="45%">
      <b-container>
        <b-row>
          <!-- <b-col cols="12">
            <div class="m-2">
              <span class="text-danger font-weight-400" v-if="!getLoginInfo.subscription.scrb_is_my_own">You're currently
                entitled to use {{ getLoginInfo.subscription.privileges.scpk_name }} report balance, please be mindful on
                purchasing the report.</span>
            </div>
          </b-col> -->
          <b-col cols="12">
            <!-- <div class="mb-3">
              <div class="mb-2 mx-2 py-3 px-4 rounded d-flex align-items-center justify-content-between"
                style="background-color: #252938;">
                <h3 class="mb-0 text-white d-flex align-items-center">
                  <span class="mr-2">Balance Report</span>
                  <span class="badge bg-fintos text-dark">{{ getLoginInfo.subscription.scrb_credit_report }}</span>
                </h3>
                <h3 class="mb-0 text-white d-flex align-items-center">
                  <span class="mr-2">Free Report</span>
                  <span class="badge bg-success text-dark">{{ getLoginInfo.subscription.scrb_free_report }}</span>
                </h3>
              </div>
              <p v-if="getLoginInfo.subscription.scrb_is_my_own || checkRoleType(['admin'])" class="text-right px-2">Need
                more reports? <a href="javascript:void(0)" @click="showReloadModal">Reload Here.</a> </p>
            </div> -->
            <div class="consent-form border rounded mx-2 mb-3 px-2 py-3" v-loading="is_loading_esign">
              <h3 class="d-flex align-items-center">
                <span class="badge bg-fintos my-auto px-2 mr-2">Step 1</span>
                <span>Upload consent form</span>
              </h3>
              <div>
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0 d-flex align-items-center"><span class="badge bg-secondary px-2 mr-1">Option 1</span>
                    Esign</h3>
                  <el-button type="text" @click="getNewConsentHandler(activeCustomer)"
                    :loading="is_generate_new_esign">Generate New Esign</el-button>
                </div>
                <div v-if="latest_consent && latest_consent.esign_status == 2">
                  <el-button type="text"
                    @click="$refs.preview_modal.preview(latest_consent.esign_attachment[1].attachment_unsigned_url)">
                    <b-icon icon="pen-fill" font-scale="1.2"></b-icon>
                    Preview Latest Esign
                  </el-button>
                  <b-form-checkbox v-model="is_use_esign" class="my-auto">
                    Use this Esign to purchase.
                  </b-form-checkbox>
                </div>
                <div v-if="latest_consent && ([0, 1].includes(latest_consent.esign_status) || is_new_esign)">
                  <b-form-group label="Share the link to e-sign" label-cols="12" content-cols="11">
                    <b-input-group class="mb-2">
                      <b-form-input v-model="latest_consent.esign_url" type="text" readonly></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" class="px-5" @click="copySignLink(latest_consent.esign_url)">
                          <b-icon icon="files" aria-hidden="true"></b-icon>
                          Copy
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <a href="javascript:void(0)" @click="getEsignConsentHandler">
                      <b-icon icon="arrow-clockwise"></b-icon>
                      Refresh
                    </a>
                  </b-form-group>
                </div>
                <p v-if="!latest_consent" class="text-muted">No Esign found / Link has expired. Please generate a new one.
                </p>
              </div>
              <div>
                <b-form-group class=" mt-0" label-cols="12">
                  <h3 class="mb-0 d-flex align-items-center"><span class="badge bg-secondary px-2 mr-1">Option 2</span>
                    Manual</h3>
                  <el-button type="text" @click="$refs.preview_modal.preview(consent_form_url)">
                    <b-icon icon="cloud-download-fill" font-scale="1.2"></b-icon>
                    Download CTOS Consent Form
                  </el-button>
                  <vue-dropzone id="consentFormDropzone" ref="consentFormDropzone" :options="dropzoneOptions"
                    :useCustomSlot=true v-on:vdropzone-error="dropzoneErrorConsentForm"
                    v-on:vdropzone-file-added="dropzoneAddedConsentForm"
                    v-on:vdropzone-removed-file="dropzoneRemovedConsentForm">
                    <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                    <p class="mb-0">Drop files here</p>
                  </vue-dropzone>
                  <small class="text-danger">Manual consent form will override Esign.</small>
                </b-form-group>
              </div>
              <div>
                <h3 class="d-flex align-items-center mb-3">
                  <span class="badge bg-fintos my-auto px-2 mr-2">Step 2</span>
                  <span>Upload front and back NRIC</span>
                </h3>
                <b-row>
                  <b-col cols="12" md="6">
                    <vue-dropzone id="frontNRICDropzone" ref="frontNRICDropzone" :options="dropzoneOptionsImage"
                      :useCustomSlot=true v-on:vdropzone-error="dropzoneErrorFrontNRIC"
                      v-on:vdropzone-file-added="dropzoneAddedFrontNRIC"
                      v-on:vdropzone-removed-file="dropzoneRemovedFrontNRIC">
                      <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                      <p class="mb-0">Front NRIC</p>
                    </vue-dropzone>
                  </b-col>
                  <b-col cols="12" md="6">
                    <vue-dropzone id="backNRICDropzone" ref="backNRICDropzone" :options="dropzoneOptionsImage"
                      :useCustomSlot=true v-on:vdropzone-error="dropzoneErrorBackNRIC"
                      v-on:vdropzone-file-added="dropzoneAddedBackNRIC"
                      v-on:vdropzone-removed-file="dropzoneRemovedBackNRIC">
                      <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                      <p class="mb-0">Back NRIC</p>
                    </vue-dropzone>
                  </b-col>
                </b-row>
                <small class="text-danger">Only JPEG/PNG file is allowed for NRIC upload.</small>
              </div>
            </div>
            <div>
              <h4 class="mb-0">FREE</h4>
              <b-form-checkbox size="lg" class="my-2" v-model="form.fintscore" disabled>
                <p class="font-weight-normal pt-1">FINTSCORE Report with Mortgage Eligibility</p>
              </b-form-checkbox>
            </div>
            <div>
              <h4 class="mb-0">Add On</h4>
              <small class="text-danger">Adding this will redirect you to payment gateway instead of deducting from
                balance/free report.</small>
              <b-form-checkbox size="lg" class="my-2" v-model="form.liabilities">
                <p class="font-weight-normal pt-1">LG - Liabilities as Guarantor
                  <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_lg_guarantor_price | moneyFormatter
                  }}</s></b>
                  <b>RM{{ ctos_addons.disounct_ctos_lg_guarantor_price | moneyFormatter }}</b>
                </p>
              </b-form-checkbox>
              <b-form-checkbox size="lg" class="my-2" v-model="form.ccris">
                <p class="font-weight-normal pt-1">CCRIS Suplementary
                  <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_ccris_price | moneyFormatter }}</s></b>
                  <b>RM{{ ctos_addons.disounct_ctos_ccris_price | moneyFormatter }}</b>
                </p>
              </b-form-checkbox>
              <b-form-checkbox size="lg" class="my-2" v-model="form.angkasa">
                <p class="font-weight-normal pt-1">Angkasa(SPGA)
                  <b class="mr-1" v-if="discount > 0"><s>RM{{ ctos_addons.ctos_angkasa | moneyFormatter }}</s></b>
                  <b>RM{{ ctos_addons.disounct_ctos_angkasa | moneyFormatter }}</b>
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col cols="12" class="border-top my-4 py-3 mx-3 text-center">
            <div class="p-3 border border-danger rounded-lg mb-4" v-if="activeCustomer">
              <p>Name: <span class="font-weight-bold">{{ activeCustomer.name }}</span></p>
              <p>NRIC: <span class="font-weight-bold">{{ activeCustomer.nric }}</span></p>
              <p>Date of Birth: <span class="font-weight-bold">{{ activeCustomer.dob }}</span></p>
              <small class="text-danger">Please make sure the above details are correct.</small>
            </div>
            <p class="font-weight-normal">You only able to purchase once the consent form is sign by the customer</p>
            <div class="d-flex justify-content-center mt-3">
              <div>
                <el-button class="bg-primary text-white" @click="purchaseReport" :loading="is_loading_purchase"><b-icon
                    icon="cart-fill"></b-icon> Purchase FintScore - only
                  <span v-if="discount > 0" class="mr-1"><s>RM{{ ctosPurchaseNoDiscountPrice | moneyFormatter }}</s>
                  </span>
                  <span>RM{{ ctosPurchasePrice | moneyFormatter }} </span>
                </el-button>
                <small class="text-green d-block mt-2" v-if="discount > 0">
                  {{ discount }}% discount applied!</small>
              </div>
            </div>
            <!-- for indicator on production -->
            <div class="text-white">
              <small v-if="CTOS_TEST_MODE === 'true'">test</small>
              <small v-else>real</small>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-drawer>
    <PreviewModal ref="preview_modal"></PreviewModal>
    <SignConsentModal :sign_form.sync="modals.sign_form"></SignConsentModal>
    <ReloadFintscoreCreditModal ref="reloadFintscoreCreditModalRef" />
  </div>
</template>
<style>
#consentFormDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}

#frontNRICDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}

#backNRICDropzone.dropzone .dz-preview .dz-progress {
  display: none !important
}

.dz-preview .dz-error-message {
  top: 0px !important;
}
</style>
<script>
import { Drawer, Button } from 'element-ui'
import vue2Dropzone, { methods } from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { axios, services, getHeader, helperFunctionMixin } from '@/assets/js/httpImports.js'
import PreviewModal from '@/components/Modal/PreviewModal'
import ReloadFintscoreCreditModal from './ReloadFintscoreCreditModal.vue'
import SignConsentModal from '@/views/CustomerProfile/CustomerModals/SignConsentModal'
import { CTOS_TEST_MODE } from '@/assets/js/config.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import { useFintscoreStore } from '@/stores/fintscoreStore'

export default {
  components: {
    vueDropzone: vue2Dropzone,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    PreviewModal,
    SignConsentModal,
    ReloadFintscoreCreditModal
  },
  mixins: [helperFunctionMixin],
  data() {
    return {
      drawerBuyFintscoreReport: false,
      dropzoneOptions: {
        url: '#',
        addRemoveLinks: true,
        maxFiles: 1,
        autoProcessQueue: false,
        acceptedFiles: "application/pdf,image/jpeg,image/png",
      },
      dropzoneOptionsImage: {
        url: '#',
        addRemoveLinks: true,
        maxFiles: 1,
        autoProcessQueue: false,
        acceptedFiles: "image/jpeg,image/png",
      },
      form: {
        government_servant: false,
        fintscore: true,
        liabilities: false,
        ccris: false,
        angkasa: false,
        consent_form: null,
        base64_consent_form: null,
        back_nric: null,
        front_nric: null,
      },
      modals: {
        sign_form: false
      },
      is_loading_purchase: false,
      initial_form_values: {},
      consent_form_url: 'https://sas.imortgage2u.com/portal/download_files/CTOS-Consent-Form-Techapp-V2.pdf',
      CTOS_TEST_MODE: CTOS_TEST_MODE,
      is_first_load: true,
      is_loading_esign: false,
      is_generate_new_esign: false,
      is_use_esign: false
    }
  },
  watch: {
    'form.government_servant'(newVal) {
      this.form.angkasa = false
      if (newVal === true) {
        this.form.angkasa = true
      }
    },
    'form.angkasa'(newVal) {
      if (newVal === false && this.form.government_servant) {
        this.form.government_servant = false
      }
    },
  },
  computed: {
    ...mapState(useAuthStore, ['getLoginInfo']),
    ...mapState(useCustomerStore, ['activeCustomer']),
    ...mapState(useFintscoreStore, ['latest_consent', 'is_new_esign', 'discount_fintscore_price', 'ctos_addons', 'discount', 'fintscore_price']),
    ctosPurchaseNoDiscountPrice() {
      let price = this.fintscore_price

      if (this.form.angkasa) {
        price += this.ctos_addons.ctos_angkasa
      }
      if (this.form.liabilities) {
        price += this.ctos_addons.ctos_lg_guarantor_price
      }
      if (this.form.ccris) {
        price += this.ctos_addons.ctos_ccris_price
      }
      return price
    },
    ctosPurchasePrice() {
      let price = this.discount_fintscore_price

      if (this.form.angkasa) {
        price += this.ctos_addons.disounct_ctos_angkasa
      }
      if (this.form.liabilities) {
        price += this.ctos_addons.disounct_ctos_lg_guarantor_price
      }
      if (this.form.ccris) {
        price += this.ctos_addons.disounct_ctos_ccris_price
      }
      return price
    },
    disableGenerate() {
      if (this.latest_consent !== null) {
        const expirationDate = new Date(this.latest_consent.cce_expired_date)
        const currentDate = new Date()
        return expirationDate > currentDate
      }
      return false
    },
  },
  mounted() {
    this.initial_form_values = { ...this.form };
  },
  methods: {
    // ...mapActions(useAuthStore, ['fetchUserInfo']),
    ...mapActions(useCustomerStore, ['generateDSR']),
    ...mapActions(useCreditReportStore, ['getCreditReport']),
    ...mapActions(useFintscoreStore, ['getNewConsent', 'getEsignConsent']),
    showReloadModal() {
      this.$refs.reloadFintscoreCreditModalRef.toggleModal()
    },
    dropzoneErrorConsentForm(file, error, xhr) {
      this.form.consent_form = null
    },
    dropzoneAddedConsentForm(file) {
      this.form.consent_form = file
    },
    dropzoneRemovedConsentForm(file, error, xhr) {
      this.form.consent_form = null
    },
    dropzoneErrorFrontNRIC() {
      this.form.front_nric = null
    },
    dropzoneAddedFrontNRIC(file) {
      this.form.front_nric = file
    },
    dropzoneRemovedFrontNRIC(file, error, xhr) {
      this.form.front_nric = null
    },
    dropzoneErrorBackNRIC(file, error, xhr) {
      this.form.back_nric = null
    },
    dropzoneAddedBackNRIC(file) {
      this.form.back_nric = file
    },
    dropzoneRemovedBackNRIC(file, error, xhr) {
      this.form.back_nric = null
    },
    async viewDetails() {
      this.drawerBuyFintscoreReport = !this.drawerBuyFintscoreReport;
      if (this.drawerBuyFintscoreReport && this.is_first_load) {
        this.is_first_load = false
        await this.getEsignConsentHandler()
      }
    },
    resetForm() {
      this.$refs.consentFormDropzone.removeAllFiles();
      this.$refs.frontNRICDropzone.removeAllFiles();
      this.$refs.backNRICDropzone.removeAllFiles();
      this.form = { ...this.initial_form_values };
    },
    async convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
    async purchaseReport() {
      if (!this.form.consent_form && !this.is_use_esign) {
        _gNotif.errorFunction(null, 'Esign / Manual Consent Form is required.')
        return
      }

      if (!this.form.front_nric || !this.form.back_nric) {
        _gNotif.errorFunction(null, 'Front and Back NRIC is required.')
        return
      }

      let max_size = 2000000 // 2mb
      // check file sizes
      if (this.form.consent_form && this.form.consent_form.size > max_size) {
        _gNotif.errorFunction(null, 'Consent Form file size is too big. Max is 2MB.')
        return
      }
      if (this.form.front_nric.size > max_size) {
        _gNotif.errorFunction(null, 'Front NRIC file size is too big. Max is 2MB.')
        return
      }
      if (this.form.back_nric.size > max_size) {
        _gNotif.errorFunction(null, 'Back NRIC file size is too big. Max is 2MB.')
        return
      }

      // check if should make direct payment or deduct from report
      let is_direct_payment = 0
      if (this.form.angkasa || this.form.ccris || this.form.liabilities) {
        is_direct_payment = 1
      }

      // check if not enough balance and not direct payment
      // if (
      //   this.getLoginInfo.subscription.scrb_credit_report == 0 &&
      //   this.getLoginInfo.subscription.scrb_free_report == 0 &&
      //   !is_direct_payment
      // ) {
      //   _gNotif.errorFunction(null, 'Please reload to purchase report.')
      //   return
      // }

      let message = "Are you sure all the details are correct?";
      if (confirm(message) == true) {
        // MANUAL OVERRIDE ESIGN
        //if has manual form, use manual
        if (this.form.consent_form) {
          this.base64_consent_form = await this.convertFileToBase64(this.form.consent_form);
        }
        // if use esign and no manual, use esign
        if (this.is_use_esign && !this.form.consent_form) {
          this.base64_consent_form = this.latest_consent.esign_attachment[1].attachment_base64
        }

        let base64_front_nric = null
        if (this.form.front_nric) {
          base64_front_nric = await this.convertFileToBase64(this.form.front_nric);
        }

        let base64_back_nric = null
        if (this.form.back_nric) {
          base64_back_nric = await this.convertFileToBase64(this.form.back_nric);
        }

        let form = {
          "test_mode": CTOS_TEST_MODE === 'true' ? true : false, // set to false will make real purchase !,
          "credit_report_scrb_id": 0,
          "credit_report_type": "individual",
          "credit_report_platform": "CTOS",
          "credit_report_cust_name": this.activeCustomer.name,
          "credit_report_cust_dob": this.activeCustomer.dob,
          "credit_report_cust_ic": this.activeCustomer.nric,
          "credit_report_angkasa": this.form.angkasa ? 1 : 0,
          "credit_report_ccris": this.form.ccris ? 1 : 0,
          "credit_report_lg_guarantor": this.form.liabilities ? 1 : 0,
          "credit_report_ssm": 0, // 1 if company purchase
          "credit_report_custom_identifier": 'im2uv2-' + this.activeCustomer.nric + '-by_user-' + this.getLoginInfo.id,
          "credit_report_conset_content": this.base64_consent_form,
          "credit_report_cust_id": this.activeCustomer.customer_id,
          "credit_report_ic_front_content": base64_front_nric,
          "credit_report_ic_back_content": base64_back_nric,
          "credit_report_generate_payment": is_direct_payment,
          "credit_report_cust_is_new": 0,
          "credit_report_redirect_url": window.location.href
        }

        if (is_direct_payment) {
          this.is_loading_purchase = true
          axios.post(services.credit_report + 'credit-report', form, { headers: getHeader() })
            .then(res => {
              this.is_loading_purchase = false
              window.location.href = res.data.pay_url
            })
            .catch(e => {
              this.is_loading_purchase = false
              _gNotif.errorFunction(e)
            })
        } else {
          this.is_loading_purchase = true
          axios.post(services.credit_report + 'credit-report', form, { headers: getHeader() })
            .then(res => {
              this.is_use_esign = false
              this.$emit('new-purchase-report')
              this.is_loading_purchase = false
              this.resetForm()
              this.drawerBuyFintscoreReport = false
              _gNotif.notifySuccess('<b>CTOS Report Purchase: </b> - Successfull.')
              this.getCreditReport()
              this.generateDSR()
              // this.fetchUserInfo() // to update report balance
              if (this.$route.query.active && this.$route.query.active !== 'commitment') {
                const query = { ...this.$route.query, active: 'commitment' };
                this.$router.push({ path: this.$route.path, query });
              }
            })
            .catch(e => {
              this.is_use_esign = false
              this.is_loading_purchase = false
              _gNotif.errorFunction(e)
            })
        }
      }
    },
    copySignLink(url) {
      this.copyToClipboard(url)
      _gNotif.notifySuccess('Esign link copied.')
    },
    async getNewConsentHandler(customer) {
      let message = "This will generate a new Esign and send an OTP message to the customer. Are you sure?";
      if (confirm(message) == true) {
        this.is_generate_new_esign = true
        try {
          await this.getNewConsent(customer)
        } catch (e) {
          _gNotif.errorFunction(e)
        }
        this.is_generate_new_esign = false
      }
    },
    async getEsignConsentHandler() {
      this.is_loading_esign = true
      await this.getEsignConsent(this.activeCustomer.customer_id)
      this.is_loading_esign = false
    }
  }
}
</script>